import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import { useTranslation } from 'react-i18next';

import { GetSaveButtonStyle as saveButtonStyle } from '../../Styles/styles';
import { ActionButton } from '../ActionButton';

export const ActionButtons = ({ onSave, onReset, on_default, title }) => {
  const { t } = useTranslation();
  return (
    <Box style={saveButtonStyle()}>
      <ActionButton
        onClick={onSave}
        disabled={on_default}
        title={title}
        color="primary"
        variant="contained"
      >
        {t('save')}
      </ActionButton>
      <Button
        onClick={(e, v) => {
          onReset(e, v);
        }}
        color="secondary"
      >
        {t('reset')}
      </Button>
    </Box>
  );
};
